export default __webpack_public_path__ + "static/media/ng.1b98819e.svg";